import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionService} from "../../../shared/services/session.service";
import {AlertPopupService} from "../../../shared/services/alert-popup.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {ForgotPassword, ResetPassword} from "../../../states/auth/auth.actions";
import {RegexEnum} from "../../../core/enums/regex.enum";

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
	public form: FormGroup;
	public otpConfig = {
		allowNumbersOnly: true, length: 6, isPasswordInput: false,
		disableAutoFocus: true, placeholder: "",
		inputStyles: { width: "70px", height: "50px" },
	};

	constructor(
		private sessionService: SessionService,
		private alertPopupService: AlertPopupService,
		private router: Router,
		private formBuilder: FormBuilder,
		private store: Store,
		private activatedRoute: ActivatedRoute,
	) {
	}

	ngOnInit(): void {
		this.subscribeToSession();
		this.initializeForm();

		/*
		* Fetching route params
		* */
		this.activatedRoute.params.subscribe(data => {
			if (data.emailId) {
				this.form.patchValue({
					emailId: data.emailId
				});
			}
		});
	}

	subscribeToSession() {
		if (this.sessionService.state?.profile) {
			this.router.navigate(['']);
			this.alertPopupService.showWarningAlert('You already have an active session!!!');
		}
	}

	initializeForm(): void {
		this.form = this.formBuilder.group({
			emailId: [null, [Validators.required, Validators.email]],
			resetToken: [null, [Validators.required, Validators.maxLength(6), Validators.minLength(6)]],
			password: [null, [Validators.required, Validators.pattern(RegexEnum.PasswordRegex)]],
		});
	}

	public markTouchedAndDirty(value: string | boolean, key: string): void {
		this.form.controls[key].markAsTouched();
		if (!value) {
			this.form.controls[key].markAsDirty();
		}
	}

	public onSubmit(form: FormGroup): void {
		try {
			if (form.valid) {
				this.store.dispatch(new ResetPassword(form.value));
			} else {
				form.markAllAsTouched();
				throw 'You missed to fill some required fields.';
			}
		} catch (e) {
			this.alertPopupService.showErrorAlert(`${e}`);
		}
	}

	doValidateOTP(event) {
		this.form.patchValue({
			resetToken: event
		});
	}
}
